import request from "./identityrequest";

const MenuService = {
    GetAll: async (context) => {
        return await request.sendRequest(`/menu/all`, context.token);
    },
    GetMenus: async (userId, context) => {
        return await request.sendRequest(`/menu/format/${userId}`, context.token);
    },
};

export default MenuService;
